import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../Auth";
import { useTranslate } from 'react-polyglot';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './Login.scss';

import {
    Button,
    Card,
    Form
} from 'react-bootstrap';
import LocaleHandler from "../../../LocaleHandler";

function Login() {
    const auth = useAuth();
    const history = useHistory();
    const t = useTranslate();
    const { setLocale } = React.useContext(LocaleHandler);

    const notifyAlert = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "alert-toast"
    });

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const updateUsername = event => setUsername(event.target.value);
    const updatePassword = event => setPassword(event.target.value);

    const handleKeyDown = event => {
        if (event.key === 'Enter') {
            login();
        }
    }

    async function login() {
        let result = await auth.signin(username, password);
        if (result != null && result["id"] == "") {
            notifyAlert(t("login.toast_wrongusernamepassword"));
        } else {
            setLocale(result["userdata"]["language"]);
            history.push("/");
        }
    }
    
    function lostPass(evt){
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        history.push("/lostpassword");
    }

    return (
        <div className="logincontainer">
            <div className="row justify-content-center">
                <div className="col-lg-5">
                    <Card>
                        <div className="card-header pt-4 pb-4 text-center login-header">
                            <a href="/">
                                <span><img src={"https://via.placeholder.com/120x120"} alt="" width="200" /></span>
                            </a>
                        </div>
                        <Card.Body>
                            <div className="welcometext">
                                <h4>{t("login.page_name")}</h4>
                                <p>{t("login.login_info")}</p>
                            </div>
                            <div className="loginform">

                                <Form>
                                    <Form.Group controlId="formBasicEmail">
                                        <Form.Label>{t("login.email")}</Form.Label>
                                        <Form.Control 
                                            type="email"
                                            placeholder={t("login.email_info")}
                                            value={username}
                                            onKeyDown={handleKeyDown}
                                            onChange={updateUsername}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="formBasicEmail">
                                        <Form.Label>{t("login.password")}</Form.Label>
                                        <Form.Control
                                            type="password"
                                            placeholder={t("login.password_info")}
                                            value={password}
                                            onKeyDown={handleKeyDown}
                                            onChange={updatePassword}
                                        />
                                    </Form.Group>
                                </Form>
                                <div className="buttonbox">
                                    <Button onClick={login}>{t("login.page_name")}</Button>
                                    <Button onClick={lostPass}>{t("login.lost_password")}</Button>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </div>
    );
}

export default Login;